export const DAY_IN_SECONDS = 86400000;
export const EMPTY_VALIDATORS: ((value: unknown) => undefined | string)[] = [];
